import "./Footer.css"

import React from 'react'
import {FaFacebook, FaHome, FaLinkedin, FaMailBulk, FaPhone, FaTwitter} from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer">
        <div className="footer-container">
            <div className="left">
                <div className="location">
                    <FaHome size={20} style={{color:"#fff", marginRight: "2rem"}}/>
                    <div>
                        <p>
                            En pruebas
                        </p>
                        <p>Pruebas</p>
                    </div>
                </div>
                <div className="phone">
                    <h4>
                        <FaPhone size={20} style={{color:"#fff", marginRight: "2rem"}}/>
                        +57 3132872428
                    </h4>
                </div>

                <div className="email">
                    <h4>
                        <FaMailBulk size={20} style={{color:"#fff", marginRight: "2rem"}}/>
                        @gmail.com
                    </h4>
                </div>
            </div>

            <div className="right">
                <h4>
                    About the company
                </h4>

                <p>
                    We are a Colombian company committed to sustainable development through photovoltaic energy solutions. We help you save, achieve energy self-sufficiency, and protect the environment, while complying with all national regulations.
                </p>
                <div className="social">    
                    <FaFacebook size={30} style={{color:"#fff", marginRight: "1rem"}}/>
                </div>

                <div className="social">    
                    <FaTwitter size={30} style={{color:"#fff", marginRight: "1rem"}}/>
                </div>

                <div className="social">    
                    <FaLinkedin size={30} style={{color:"#fff", marginRight: "1rem"}}/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer
